import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { PermissionsProvider } from "@/hooks/usePermissions";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import RecoverAdmin from "@/pages/RecoverAdmin";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import AppLayout from "@/components/AppLayout";
import Dashboard from "@/pages/Dashboard";
import RFQList from "@/pages/RFQList";
import RFQDetail from "@/pages/RFQDetail";
import CreateRFQ from "@/pages/buyer/CreateRFQ";
import Transactions from "@/pages/Transactions";
import Suppliers from "@/pages/admin/Suppliers";
import Users from "@/pages/admin/Users";
import Kanban from "@/pages/admin/Kanban";

const Protected = ({ children }) => {
  const { user } = useAuth();
  if (user === null) return <div className="p-10 text-slate-500">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

function App() {
  return (
    <AuthProvider>
      <PermissionsProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/recover-admin" element={<RecoverAdmin />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route element={<Protected><AppLayout /></Protected>}>
            <Route path="/app" element={<Dashboard />} />
            <Route path="/app/rfqs" element={<RFQList />} />
            <Route path="/app/rfqs/new" element={<CreateRFQ />} />
            <Route path="/app/rfqs/:id" element={<RFQDetail />} />
            <Route path="/app/transactions" element={<Transactions />} />
            <Route path="/app/suppliers" element={<Suppliers />} />
            <Route path="/app/users" element={<Users />} />
            <Route path="/app/kanban" element={<Kanban />} />
          </Route>
        </Routes>
      </BrowserRouter>
      </PermissionsProvider>
    </AuthProvider>
  );
}
export default App;
